/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Button,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteModal from "components/deletemodal/deletemodal";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { deleteLoadPlanVehiclesRecords, fetchLoadPlanVehicles } from "utils/api";
import { appConstants } from "utils/appConstants";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";



let searchParameter = "";
let LOGIN_DETAILS;
let EMPLOYEE_DETAILS;
function Vehicles() {
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [rows, setRows] = useState([]);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const dispatch = useDispatch();
  const [load, setLoad]=useState([])

  const [values, setValues] = React.useState({

    _id: [],
    sortingType: "",
    sortingField: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",

    searchParameter: '',
    searchParameterList: ["vehicleCategory", "registrationNumber", "equipmentID", "location", "registrationExpiryDate", "vehicleStatus",],
    vehicleCategory: '',
    vehicleregistrationNumber: '',
    maximumVolume: "",
    maximumWeight: "",
    shippingType: "",

  });

  LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
  values.businessUserID = LOGIN_DETAILS.businessUserID
  EMPLOYEE_DETAILS = JSON.parse(sessionStorage.getItem('Employee_Details'));
  values.warehouseID = EMPLOYEE_DETAILS.employeeWarehouseLocation;


  useEffect(() => {
    (async () => {
      await fetchLoadPlanVehiclesByID();
    })();
  }, [values.sortingType, perPage, dispatch]);


  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDeleteDialogeClick = async (_id) => {
    values._id = []
    values._id.push(_id)
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDelete = async (id) => {
    deleteLoadPlanVehicles();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = page => {
    values.page = page;
    fetchLoadPlanVehiclesByID();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const contextActions = useMemo(() => {
    const handleDeleteMultiple = () => {
      setDeleteDialogeFlag(!deleteDialogeFlag);
      setDeleteHeading("Would you like to delete selected records?");
      if (selectedRows) {
        values._id = []
        for (let element of selectedRows) {
          values._id.push(element._id);
        }
      }
    };
    return (
      <MDButton onClick={handleDeleteMultiple} color="error" >
        Delete
      </MDButton>
    );
  }, [selectedRows, toggleCleared]);

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
    if (state.selectedRows.length > 0) {
      setTitle(" ");
    }
    else {
      setTitle("");
      setDeleteHeading("");
    }
  }, []);


  const deleteLoadPlanVehicles = async () => {
    await deleteLoadPlanVehiclesRecords(values, (data) => {
      fetchLoadPlanVehiclesByID();
      setToggleCleared(true);
      setTitle("");
      showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)
  };

  const fetchLoadPlanVehiclesByID = async () => {
    values.searchParameter = searchParameter;
    await fetchLoadPlanVehicles(values, (data) => {
      setTotalRows(data.Result_Output.totalDocs);
      setRows(data.Result_Output.docs)
    }, dispatch)
  };


  let columns = [
    {
      name: "Vehicle Category",
      selector: row => row.vehicleCategory,
      sortable: true,
      sortField: 'vehicleCategory',
    },
    {
      name: "Vehicle registration Number",
      selector: row => row.registrationNumber,
      sortable: true,
      sortField: 'registrationNumber',
    },
    {
      name: "Vehicle Status",
      selector: row => row.vehicleStatus,
      sortable: true,
      sortField: 'vehicleStatus',
    },
    {
      name: "Actions",
      selector: row => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              <Link
                to={`/loadVehicles/editLoadVehicles/edit/${row._id}`}
              >
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
            <Grid item >
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />
            </Grid>

          </Grid>
        </>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Load Plan Vehicle" />
          <Grid container display={"flex"} justifyContent="end" mt={2} gap={2} px={2.2}>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchLoadPlanVehiclesByID}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: '16px' }}>
              <Link to={"/loadVehicles/addLoadVehicles"}>
                <MDButton
                  variant="contained"
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  color={disableColor ? "secondary" : "success"} >
                  Add New
                </MDButton>
              </Link>
            </div>
          </Grid>
          <CardContent>
            <BTable
              title={title}
              columns={columns}
              data={rows}
              selectableRows
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              contextActions={contextActions}
              onSelectedRowsChange={handleRowSelected}
              clearSelectedRows={toggleCleared}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}
            />
          </CardContent>
        </Card>
      </div >
      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
        heading={deleteHeading}
      />
    </DashboardLayout>
  );

}

export default Vehicles;
